"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGroupedSetDiff = void 0;
var utils_1 = require("../../../utils");
var grouped_set_diff_1 = require("./grouped-set-diff");
/**
 *
 * @param oldSet 変更前の集合
 * @param newSet 変更後の集合
 * @param idSelector （要素がobjectの場合）要素の同一性判定に使うメンバーを取り出す関数（`e => e.id`など）．
 * idが同じで中身のみ更新されている要素を `updated` の項目とするために使用する．
 * `number`等primitiveの集合である場合は`e => e`をダミーとして用いる（primitiveの場合は `updated` は常に空となる）．
 */
var getGroupedSetDiff = function (oldSet, newSet, idSelector) {
    if (idSelector === void 0) { idSelector = function (e) { return e; }; }
    if (oldSet === undefined) {
        return (0, grouped_set_diff_1.IGroupedSetDiff)({
            deleted: (0, utils_1.ISet)(),
            added: newSet,
            updated: (0, utils_1.ISet)()
        });
    }
    else {
        // TODO: Set.includesの使用を最小限に抑えたアルゴリズムに修正し高速化する
        var oldElements = oldSet.subtract(newSet); // oldSetに存在しnewSetに存在しない要素
        var newElements = newSet.subtract(oldSet); // newSetに存在しoldSetに存在しない要素
        var idsInOldElements = oldElements.map(idSelector);
        var idsInNewElements = newElements.map(idSelector);
        var commonIds_1 = idsInOldElements.intersect(idsInNewElements);
        var isUpdatedElement = function (e) { return commonIds_1.includes(idSelector(e)); };
        var updated = newElements.filter(isUpdatedElement);
        var added = newElements.filterNot(isUpdatedElement);
        var deleted = oldElements.filterNot(isUpdatedElement);
        return (0, grouped_set_diff_1.IGroupedSetDiff)({ deleted: deleted, added: added, updated: updated });
    }
};
exports.getGroupedSetDiff = getGroupedSetDiff;
